import { ROUTE_PAGE_HOME, SITEMAP_REPORT } from '@components/Router/constants'
import { parseNestError } from '@store/reducers/dashboard/utils'
import { ErrorNotification } from '@storeOld/reducers/notification'
import type React from 'react'
import { useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { generatePath, useNavigate } from 'react-router-dom'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import { useAuth } from '@/hooks'
import { NestClient } from '@/nest'
import { CRAWLER_HANDOFF_KEY, readHandoff, siteUrlOf } from './utils'

const PromoReport: React.FC = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { authenticated } = useAuth()
  // Creating is not idempotent, and React mounts effects twice in dev.
  const started = useRef(false)

  useEffect(() => {
    if (started.current) {
      return
    }

    started.current = true

    const crawl = readHandoff()
    const siteUrl = crawl && siteUrlOf(crawl)

    if (!crawl || !siteUrl) {
      navigate(ROUTE_PAGE_HOME)

      return
    }

    NestClient.sitemapReport
      .create({
        crawl: {
          faviconUrl: crawl.extra?.icon ?? null,
          // Pages and issues are one list to the API: a 404 or a redirect is a
          // row in the report, even though it never becomes a page in a sitemap.
          pages: [...(crawl.data ?? []), ...(crawl.issues ?? [])],
          title: crawl.extra?.title ?? null,
          url: siteUrl,
        },
      })
      .then(({ id }) => {
        // A guest's report is counted when it is saved, not when it is made.
        if (authenticated) {
          sendGtmEvent(GtmTriggerName.REPORT_CREATE_COMPLETED)
        }

        localStorage.removeItem(CRAWLER_HANDOFF_KEY)
        navigate(generatePath(SITEMAP_REPORT, { uuid: id }))
      })
      .catch((error) => {
        dispatch(ErrorNotification(parseNestError(error)))
        navigate(ROUTE_PAGE_HOME)
      })
  }, [])

  return null
}

export default PromoReport
